import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { RevealHeading, Reveal } from "@/components/Reveal";
import { ArrowUpRight, BookOpen } from "lucide-react";

export default function Resources() {
  const [resources, setResources] = useState([]);

  useEffect(() => {
    api.get("/resources").then((r) => setResources(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-void min-h-screen" data-testid="resources-page">
      <Navbar />
      <section className="pt-32 md:pt-44 pb-16 md:pb-24 border-b border-[#222]">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-neon mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-neon" /> Knowledge Base
          </div>
          <h1 className="font-display uppercase text-6xl md:text-8xl lg:text-[10vw] leading-[0.82] tracking-tight">
            <RevealHeading lines={["Resources"]} />
          </h1>
          <p className="mt-8 font-mono text-sm md:text-base text-[#9CA3AF] max-w-xl">
            Guides, recommendations and honest information to help you get the most out of your build.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[1600px] px-5 md:px-10 py-16 md:py-24">
        {resources.length === 0 ? (
          <div className="font-mono text-[#9CA3AF]">No resources yet.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-[#222]">
            {resources.map((r, i) => {
              const Wrap = r.link ? "a" : "div";
              const props = r.link ? { href: r.link, target: "_blank", rel: "noreferrer" } : {};
              return (
                <Reveal key={r.id} delay={(i % 3) * 0.06}>
                  <Wrap {...props} data-testid={`resource-card-${r.id}`} className="group block border-r border-b border-[#222] bg-matte p-8 hover:bg-panel transition-colors h-full">
                    <div className="flex items-center justify-between">
                      <BookOpen className="text-neon" size={28} />
                      {r.link && <ArrowUpRight className="text-[#9CA3AF] group-hover:text-neon transition-colors" size={20} />}
                    </div>
                    <h3 className="mt-8 font-grotesk font-bold text-2xl text-[#FAFAFA] group-hover:text-neon transition-colors">{r.title}</h3>
                    <p className="mt-3 font-mono text-sm text-[#9CA3AF] leading-relaxed">{r.description}</p>
                  </Wrap>
                </Reveal>
              );
            })}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
